import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { useCallback, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { trackButtonClick } from '../../v2/utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const PricingPlanToggleButton = ({
  tier
}) => {
  const location = useLocation();
  const history = useHistory();
  const scrollPositionRef = useRef(0);
  const handleToggle = useCallback(() => {
    // Capture current scroll position
    scrollPositionRef.current = window.scrollY;
    const searchParams = new URLSearchParams(location.search);
    const isCurrentlyEnterprise = tier === 'enterprise';
    if (isCurrentlyEnterprise) {
      // Currently showing only Pro/Enterprise, remove tier param to show all plans
      searchParams.delete('tier');
    } else {
      // Currently showing all plans, add tier=enterprise to show only Pro/Enterprise
      searchParams.set('tier', 'enterprise');
    }

    // Track the toggle action
    trackButtonClick({
      action: isCurrentlyEnterprise ? 'clicked show all plans toggle' : 'clicked view enterprise plans toggle',
      value: isCurrentlyEnterprise ? 'show_all_plans' : 'view_enterprise_plans'
    });

    // Use replace instead of push to avoid scroll restoration behavior
    history.replace({
      pathname: location.pathname,
      search: searchParams.toString()
    });

    // Restore scroll position after URL update
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollPositionRef.current);
    });
  }, [tier, location.pathname, location.search, history]);
  const buttonTextKey = tier === 'enterprise' ? 'pricingPage.toggleButton.showAllPlans' : 'pricingPage.toggleButton.viewEnterprisePlans';
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    paddingBlockStart: "400",
    children: /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: handleToggle,
      "aria-pressed": tier === 'enterprise',
      "data-selenium-id": "pricing-plan-toggle-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: buttonTextKey
      })
    })
  });
};
export default PricingPlanToggleButton;